import FRONTCARDS from '../utils/frontCardValues';
import { fetchData } from './fetchData';

export const getData = async () => {
  const data = await fetchData();

  FRONTCARDS['1'].Monthly[1].priceText = `$${data.subscription_tier.starter.monthly.price}/mo`;
  FRONTCARDS['1'].Monthly[1].priceId = data.subscription_tier.starter.monthly.id;

  FRONTCARDS['1'].Monthly[3].priceText = `$${data.subscription_tier.professional.monthly.price}/mo`;
  FRONTCARDS['1'].Monthly[3].priceId = data.subscription_tier.professional.monthly.id;

  FRONTCARDS['1'].Monthly[4].priceText = 'Get a Quote';
  FRONTCARDS['2-9'].Monthly[1].priceText = `$${data.subscription_tier.starter.monthly.price}/mo`;
  FRONTCARDS['2-9'].Monthly[3].priceText = `$${data.subscription_tier.professional.monthly.price}/mo`;
  FRONTCARDS['2-9'].Monthly[4].priceText = 'Get a Quote';

  FRONTCARDS['1'].Monthly[1].price = data.subscription_tier.starter.monthly.price;
  FRONTCARDS['1'].Monthly[3].price = data.subscription_tier.professional.monthly.price;
  FRONTCARDS['2-9'].Monthly[1].price = data.subscription_tier.starter.monthly.price;
  FRONTCARDS['2-9'].Monthly[3].price = data.subscription_tier.professional.monthly.price;

  return data.subscription_tier;
};

export default getData;
